// extracted by mini-css-extract-plugin
export var filterIncDec = "_cn-0";
export var leftBorder = "_cn-1";
export var rightBorder = "_cn-2";
export var stringInput = "_cn-3";